module.exports = __webpack_public_path__ + "static/media/lightning-rainy.svg.a87085b2.png";